module.exports = __webpack_public_path__ + "img/39@2x.446fdd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/39@2x.png
// module id = LfqU
// module chunks = 0